/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Container as RContainer } from 'reactstrap';

// eslint-disable-next-line react/prefer-stateless-function
class Container extends React.Component {
  render() {
    return <RContainer {...this.props}>{this.props.children}</RContainer>;
  }
}

Container.propTypes = {
  children: PropTypes.any,
};

export default Container;
